import { queryOptions, useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const homepageSettingsQueryOptions = queryOptions({
  queryKey: ['homepage-settings'],
  queryFn: async () => {
    const { data, error } = await supabase
      .from('page_settings')
      .select('settings')
      .eq('page_type', 'homepage')
      .maybeSingle();

    if (error) throw error;
    return data?.settings || {};
  },
  staleTime: 30 * 60 * 1000, // 30 minutes
  gcTime: 60 * 60 * 1000,
});

export const useHomepageSettings = () => useQuery(homepageSettingsQueryOptions);
